<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "../../router/index.js";
import {listServiceItem} from "@/api/serviceItem/serviceItem.js";
import {listAdvertisementPosition} from "@/api/advertisementPosition/advertisementPosition.js";
import {
  changeAdvertisementToOffline,
  listAdvertisement,
  listAdvertisementOfPendingOnline,
  listAdvertisementOfPendingReview, setAdvertisementDefault
} from "@/api/advertisement/advertisement.js";

/*初次加载*/
onMounted(() => {
  handleGetAdvertisementPosition()
  handleSearch()
})
// 获取上架位置
const handleGetAdvertisementPosition = async () => {
  try {
    loading.value = true
    let param = {
      page: 1,
      pageSize: 100,
    }
    const res = await listAdvertisementPosition(param)
    saleLocationEnum.value = res.list
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*搜索功能*/
// 表单数据
const formData = reactive({
  advertisementName: null,
  positionId: null,
  sort: null,
  state: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    let res = {}
    if (currentListType.value === 1) {
      res = await listAdvertisement(param.value, formData)
    } else if (currentListType.value === 2) {
      formData.state = null
      res = await listAdvertisementOfPendingOnline(param.value, formData)
    } else if (currentListType.value === 3) {
      res = await listAdvertisementOfPendingReview(param.value, formData)
    }
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.advertisementName = null
  formData.positionId = null
  formData.sort = null
  formData.state = null
  handleSearch('btnSearch')
}
// 当前列表
const currentListType = ref(1) // 1广告列表 2待上架 3待审批
// 处理改变列表状态
const handleChangeListType = (type) => {
  if (type === currentListType.value) return console.log("点击了当前列表，不作操作")
  currentListType.value = type
  handleSearch('btnSearch')
}
// 上架位置枚举
const saleLocationEnum = ref([])
// 上架轮播图位置枚举
const saleLocationNumEnum = [
  {
    sort: 0,
    sortName: "默认"
  },
  {
    sort: 1,
    sortName: "轮播图1号位"
  },
  {
    sort: 2,
    sortName: "轮播图2号位"
  },
  {
    sort: 3,
    sortName: "轮播图3号位"
  },
  {
    sort: 4,
    sortName: "轮播图4号位"
  },
  {
    sort: 5,
    sortName: "轮播图5号位"
  },
  {
    sort: 6,
    sortName: "轮播图6号位"
  },
]
// 广告状态枚举
const advStateEnum = [
  {
    stateId: "PENDING_ONLINE",
    stateName: "待上架"
  },
  {
    stateId: "ONLINE",
    stateName: "已上架"
  },
  {
    stateId: "OFFLINE",
    stateName: "已下架"
  },
  {
    stateId: "PENDING_REVIEW",
    stateName: "待审批"
  },
  {
    stateId: "APPROVED",
    stateName: "已通过"
  },
  {
    stateId: "REJECTED",
    stateName: "已驳回"
  },
]
// 处理上架位置反显
const handleReviewLocation = (id, sort) => {
  const target = saleLocationEnum.value.find(i => i.positionId === id)
  const targetOrder = saleLocationNumEnum.find(i => i.sort === sort)
  return target ? target.positionName + " - " + targetOrder?.sortName : "-"
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  {title: '编号', key: 'advertisementId', width: "120px", nowrap: true},
  {title: '名称', key: 'advertisementName', width: "120px", nowrap: true},
  {title: '上架位置', key: 'positionId', width: "150px", nowrap: true},
  {title: '是否默认广告', key: 'isDefault', width: "150px", nowrap: true},
  {title: '上架时间', key: 'onlineTime', width: "250px", nowrap: true},
  {title: '下架时间', key: 'offlineTime', width: "250px", nowrap: true},
  {title: '广告有效期', key: 'effectiveValue', width: "150px", nowrap: true},
  {title: '广告状态', key: 'state', width: "150px", nowrap: true},
  {title: '操作', key: 'controls', width: "120px", fixed: true},
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 添加广告
const handleAdd = () => {
  router.push({ path: 'editAdvertisements' })
}

/*操作栏功能*/
// 详情
const handleRead = (info) => {
  router.push({path: "/readOnlyAdvertisements", query: {advertisementId: info.advertisementId}})
}
// 编辑
const handleEdit = (info) => {
  router.push({path: '/editAdvertisements', query: {advertisementId: info.advertisementId}})
}
// 审批
const handleAudit = (info) => {
  router.push({path: "/auditAdvertisements", query: {advertisementId: info.advertisementId}})
}
// 上架
// const setSale = (info) => {
//   try {
//     loading.value = true
//
//     handleSearch()
//     loading.value = false
//   } catch (e) {
//     console.log(e)
//     loading.value = false
//   }
// }
// 下架
const setUnSale = async (info) => {
  try {
    loading.value = true
    console.log("info.advertisementId", info)
    await changeAdvertisementToOffline(info.advertisementId)
    await handleSearch()
    ElMessage.success("下架成功")
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 设置默认广告
const setDefault = async (info, isDefault) => {
  try {
    loading.value = true
    await setAdvertisementDefault(info.advertisementId, isDefault)
    await handleSearch()
    ElMessage.success(isDefault ? "设置默认广告成功" : "取消默认广告成功")
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">新建广告
      </v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="2">
                    <v-text-field
                        v-model="formData.advertisementName"
                        placeholder="请输入广告名称"
                        label="广告名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                        v-model="formData.positionId"
                        placeholder="选择上架位置"
                        variant="outlined"
                        label="上架位置"
                        clearable
                        :items="saleLocationEnum"
                        item-title="positionName"
                        item-value="positionId"
                    ></v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                        v-model="formData.sort"
                        placeholder="选择轮播图位置"
                        variant="outlined"
                        label="上架轮播图位置"
                        clearable
                        :items="saleLocationNumEnum"
                        item-title="sortName"
                        item-value="sort"
                    ></v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                        v-if="currentListType !== 2"
                        v-model="formData.state"
                        placeholder="选择广告状态"
                        variant="outlined"
                        label="广告状态"
                        clearable
                        :items="advStateEnum"
                        item-title="stateName"
                        item-value="stateId"
                    ></v-select>
                  </v-col>

                  <v-col cols="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索
                        </v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset">重置
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <div class="flex_right">
              <v-btn class="cursor-pointer" :color="currentListType === 1 ? 'primary' : '#75a2d3'" @click="handleChangeListType(1)">广告列表</v-btn>
              <v-btn class="cursor-pointer" :color="currentListType === 2 ? 'success' : '#69b76c'" @click="handleChangeListType(2)">待上架</v-btn>
              <v-btn class="cursor-pointer" :color="currentListType === 3 ? 'error' : '#c9898b'" @click="handleChangeListType(3)">待审批</v-btn>
            </div>
          </template>

          <template v-slot:item.isDefault="{ item }">
            <el-text v-if="item.isDefault" type="success">是</el-text>
            <div v-else>否</div>
          </template>

          <template v-slot:item.positionId="{ item }">
            {{handleReviewLocation(item.positionId, item.sort)}}
          </template>

          <template v-slot:item.effectiveValue="{item}">
            <div>
              {{item.effectiveValue}}
              <span v-if="item.effectiveType === 'DAY'">天</span>
              <span v-if="item.effectiveType === 'MONTH'">月</span>
              <span v-if="item.effectiveType === 'YEAR'">年</span>
            </div>
          </template>

          <template v-slot:item.state="{item}">
            <div v-if="currentListType !== 3">
              <span v-if="item?.state === 'PENDING_ONLINE'">待上架</span>
              <span v-if="item?.state === 'ONLINE'">已上架</span>
              <span v-if="item?.state === 'OFFLINE'">已下架</span>
            </div>
            <div v-else>
              <span v-if="item?.reviewState === 'PENDING_REVIEW'">待审批</span>
              <span v-if="item?.reviewState === 'APPROVED'">已通过</span>
              <span v-if="item?.reviewState === 'REJECTED'">已驳回</span>
            </div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left flex_center">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="详情"
                  placement="left">
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-list-box-outline" color="warning" @click="handleRead(item)"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="top">
                <v-icon v-if="item.isCurrentUser" class="cursor-pointer mg_r_1" icon="mdi-file-edit-outline" color="primary" @click="handleEdit(item)"></v-icon>
              </el-tooltip>
<!--              <el-popconfirm @confirm="setSale(item)" :title="`上架“${item.advertisementName}”`">-->
<!--                <template #reference>-->
<!--                  <div>-->
<!--                    <el-tooltip-->
<!--                        class="box-item flex_center"-->
<!--                        effect="dark"-->
<!--                        content="上架"-->
<!--                        placement="top">-->
<!--                      <v-icon v-if="currentListType !== 3 && item?.state === 'OFFLINE'" class="cursor-pointer mg_r_1" icon="mdi-tray-arrow-up" color="success"></v-icon>-->
<!--                    </el-tooltip>-->
<!--                  </div>-->
<!--                </template>-->
<!--                <template #actions="{ confirm, cancel }">-->
<!--                  <div class="flex_bt">-->
<!--                    <v-btn size="small" @click="cancel">取消</v-btn>-->
<!--                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>-->
<!--                  </div>-->
<!--                </template>-->
<!--              </el-popconfirm>-->
              <el-popconfirm @confirm="setUnSale(item)" :title="`下架“${item.advertisementName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item flex_center"
                        effect="dark"
                        content="下架"
                        placement="top">
                      <v-icon v-if="currentListType !== 3 && item?.state === 'ONLINE' && !item.isDefault" class="cursor-pointer mg_r_1" icon="mdi-tray-arrow-down" color="error"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm @confirm="setDefault(item, true)" :title="`设置“${item.advertisementName}”为默认广告？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item flex_center"
                        effect="dark"
                        content="设为默认广告"
                        placement="top">
                      <v-icon v-if="currentListType === 1 && !item?.isDefault && item.state !== 'OFFLINE'" class="cursor-pointer mg_r_1" icon="mdi-cog-outline" color="success"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm @confirm="setDefault(item, false)" :title="`取消“${item.advertisementName}”为默认广告？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item flex_center"
                        effect="dark"
                        content="取消默认广告"
                        placement="top">
                      <v-icon v-if="currentListType === 1 && item?.isDefault" class="cursor-pointer mg_r_1" icon="mdi-cog-off-outline" color="error"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="审批"
                  placement="top">
                <v-icon v-if="currentListType === 3 && item.reviewState === 'PENDING_REVIEW' && !item.isCurrentUser" class="cursor-pointer mg_r_1" icon="mdi-pencil-outline" color="error" @click="handleAudit(item)"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
